import 'rxjs/add/operator/share';
import 'rxjs/add/operator/startWith';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
var AppGlobals = (function () {
    function AppGlobals() {
        this.baseURL = new BehaviorSubject('');
        this.accessToken = new BehaviorSubject(null);
        this.isUserLoggedIn = new BehaviorSubject(false);
        this.isInvalidToken = false; // If this value true then we will show Access Denied page else we have to redirect it -> services/externaluser/login
        /**userInfo is used to store current user profile information (authenticate user) */
        this.userInfo = new BehaviorSubject(null);
        //decide the list of menu to be shown based on the user logged in
        this.leftMenusList_CUser = new BehaviorSubject(null);
        // used to store logout url based on the user logged in
        this.logoutURL = new BehaviorSubject(null);
        // used to store the username of the user who failed to log in
        this.userAttemptingToLogin = new BehaviorSubject(null);
        //looks like no use in application needs to verify
        this.currentRoute = new BehaviorSubject('');
        //used when site admin change its role to exam scheduler(candidate)
        this.acType = new BehaviorSubject(null);
        this.selectedUserId = 0;
        this.googleMapAPIKey = '';
        this.selectedExamModel = null; // When click on any card then save exam information in this object so that we can use it on other component
        this.selectedExamLocationModel = null; // When click on any Exam location then save that location info here.
        this.userPermissions = new BehaviorSubject(new Set());
    }
    Object.defineProperty(AppGlobals.prototype, "userId", {
        /**
         * This property will be used when admin works as Candidate - at that time we have to pass loggedIn userId value in candidate's apis
         * When Candidate will login - then in all apis - userId value will be 0.
         */
        get: function () {
            return this.selectedUserId;
        },
        set: function (value) {
            this.selectedUserId = value;
        },
        enumerable: true,
        configurable: true
    });
    return AppGlobals;
}());
export { AppGlobals };



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Services/app.global.ts.pre-build-optimizer.js